module.exports = __webpack_public_path__ + "img/nav-appeal.390ddaa9.svg";